module.exports = __webpack_public_path__ + "img/room-event-star_zh.202db4dc.png";